import React from 'react'

import { useNavigation } from '@react-navigation/native'
import { Icon, colors } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { Stack, XStack } from '@zet/design-system/layout'
import { B1, SH1 } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user'

import { i18n } from '../../localization'
import EmptyLeadIcon from '../../svg/EmptyLeadIcon'

const EmptyLead = () => {
  const { data: user } = useUserContext()
  const navigation = useNavigation()
  return (
    <Stack className="border-b-grays-30 mb-1 bg-white pb-4">
      <Stack className=" mb-4 mt-4 self-center rounded-lg px-2 py-2">
        <EmptyLeadIcon />
      </Stack>
      <SH1 className="text-grays-60 mx-4 mb-4 text-center">
        {i18n.t('emptyLead.title', { name: user?.name })}
      </SH1>
      <Stack className="mx-3 mb-3">
        <Button
          className="w-40 self-center"
          size="lg"
          outlined={true}
          onPress={() =>
            navigation.navigate('KnowYourCustomer', { source: 'emptyLeads' })
          }
        >
          <XStack className=" items-center justify-center space-x-2">
            <Icon
              type="RupeeCircleFilled"
              color={colors.primary[100]}
              size={24}
            />
            <B1 className="text-primary-100">{i18n.t('myLeads.sell')}</B1>
          </XStack>
        </Button>
      </Stack>
    </Stack>
  )
}

export default EmptyLead
